import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';

const ThreeAnimation = () => {
  const canvasRef = useRef(null);
  let renderer, scene, camera, particle;
  useEffect(() => {
    // Initialize the Three.js scene
    if (!renderer) {
      init();
      animate();
    }
  }, []);

  const init = () => {
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio((window.devicePixelRatio) ? window.devicePixelRatio : 1);
    renderer.setSize(window.innerWidth, 500);
    renderer.autoClear = false;
    renderer.setClearColor(0x000000, 0.0);
    const canvas = canvasRef.current;
    canvas.appendChild(renderer.domElement);

    scene = new THREE.Scene();

    camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1000);
    camera.position.z = 400;
    scene.add(camera);

    particle = new THREE.Object3D();

    scene.add(particle);

    let geometry = new THREE.TetrahedronGeometry(2, 0);

    let material = new THREE.MeshPhongMaterial({
      color: 0xffffff,
      flatShading: true
    });

    for (let i = 0; i < 1000; i++) {
      let mesh = new THREE.Mesh(geometry, material);
      mesh.position.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize();
      mesh.position.multiplyScalar(90 + (Math.random() * 700));
      mesh.rotation.set(Math.random() * 2, Math.random() * 2, Math.random() * 2);
      particle.add(mesh);
    }

    let ambientLight = new THREE.AmbientLight(0x999999 );
    scene.add(ambientLight);

    let lights = [];
    lights[0] = new THREE.DirectionalLight( 0xffffff, 1 );
    lights[0].position.set( 1, 0, 0 );
    lights[1] = new THREE.DirectionalLight( 0x11E8BB, 1 );
    lights[1].position.set( 0.75, 1, 0.5 );
    lights[2] = new THREE.DirectionalLight( 0x8200C9, 1 );
    lights[2].position.set( -0.75, -1, 0.5 );
    scene.add( lights[0] );
    scene.add( lights[1] );
    scene.add( lights[2] );
    window.addEventListener('resize', onWindowResize, false);
  };

  const onWindowResize = () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, 500);
  }

  const animate = () => {
    requestAnimationFrame(animate);

    particle.rotation.x += 0.0000;
    particle.rotation.y -= 0.0020;
    renderer.clear();

    renderer.render( scene, camera )
  }

  return (
    <div style={{height: 500}}>
      <div className='three-animation' ref={canvasRef} />
      <div className="flex h-full items-center justify-center">
        <img className="h-[440px]" src={'/alchemis.gif'}/>
      </div>
    </div>
  );
}
export default ThreeAnimation;
